import React from 'react';

import { StyleSheet, View } from 'react-native';

import Currency from 'components/currency';
import { Typography } from 'components/ui';
import { t } from 'state/intl/translations';

interface PrepaidBalanceInfoProps {
  prepaidBalance: number;
  orderTotal: number;
}

export const PrepaidBalanceInfo: React.FC<PrepaidBalanceInfoProps> = ({
  prepaidBalance,
  orderTotal,
}) => {
  const amountLeft = Math.max(orderTotal - prepaidBalance, 0);

  return (
    <>
      <View style={styles.row}>
        <Typography fontSize="sm">
          {t('prepaidCardBalance', { cardAlias: t('cardAlias.bk') })}
        </Typography>
        <Currency amount={prepaidBalance} textProps={{ style: styles.currency, fontSize: 'sm' }} />
      </View>
      <View style={styles.row}>
        <Typography fontSize="sm">{t('amountLeft', 'Amount Left')}</Typography>
        <Currency amount={amountLeft} textProps={{ style: styles.currency, fontSize: 'sm' }} />
      </View>
      <View style={styles.row}>
        <Typography fontSize="sm">{t('orderTotal', 'Order Total')}</Typography>
        <Currency amount={orderTotal} textProps={{ style: styles.currency, fontSize: 'sm' }} />
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  currency: {
    margin: 0,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 2,
    marginBottom: 2,
  },
});
